import { cn } from '../../../lib/styles';
import { Button } from '../button/button.spark';
import { Heading } from '../heading/heading.spark';
import { Icon } from '../icon/icon.spark';
import { Text } from '../text/text.spark';
import { emptyStateModel } from './empty-state.shared';
import { EmptyStateIllustration } from './illustrations';
import type { EmptyStateProps } from './types';

export function EmptyState(props: EmptyStateProps) {
  const model = emptyStateModel(props);

  return (
    <div
      className={cn(
        'mx-auto flex max-w-md flex-col items-center gap-4',
        model.compact ? 'py-6' : 'py-12',
      )}
    >
      {model.illustration && (
        <EmptyStateIllustration imageType={model.illustration} className="size-48" />
      )}
      {model.searchIcon && (
        <span className="flex size-12 items-center justify-center rounded-full bg-spark-surface-muted text-spark-text-secondary">
          <Icon name="search" size="md" />
        </span>
      )}
      <div className="flex w-full flex-col items-center gap-1">
        <Heading level="h2" style={model.compact ? 'sm' : 'md'}>
          {model.title}
        </Heading>
        {model.description && (
          <span className="text-center">
            <Text variant="secondary">{model.description}</Text>
          </span>
        )}
        {model.availability && <div className="mt-3">{model.availability}</div>}
        {model.actions.length > 0 && (
          <div className="mt-3 flex flex-wrap items-center justify-center gap-3">
            {model.actions.map((action) => (
              <Button
                key={action.label}
                variant={action.variant}
                icon={action.icon}
                disabled={action.disabled}
                loading={action.loading}
                onClick={action.onClick}
              >
                {action.label}
              </Button>
            ))}
          </div>
        )}
        {model.details && <div className="mt-6 w-full">{model.details}</div>}
      </div>
    </div>
  );
}
